import React from 'react';
import { useState, useEffect } from 'react';
import UiService from './../../../../../service/ui';
import { NavLink } from 'react-router-dom';
import theme from './../../../../theme';
import ResizeService from './../../../../../service/resize';

const Exchange = ({ exchange }) => {
    const getWidgetExchangesStyle = () => theme.getWidgetExchangesStyle(theme);
    const [ widgetExchangesStyle, setWidgetExchangesStyle ] = useState(getWidgetExchangesStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setWidgetExchangesStyle( getWidgetExchangesStyle() );
    });
    useEffect(resizeEffect);
    return (
        <div style={widgetExchangesStyle}>
            <NavLink 
                style={{ ...theme.getGeneralTextLinkStyle(theme) }} 
                to={`/exchange/${exchange.id}`}
            >
                <h4 style={{
                    ...theme.getMediumTextStyle(theme),
                }}>
                    { exchange.title }
                </h4>
                <p style={{
                    ...theme.getSmallTextStyle(theme),  
                }}>
                    { UiService.timeSince(exchange.createdOn) }
                </p>
            </NavLink>
        </div>
    );
};

const PopulatedView = ({ list }) => {
    const getUserWidgetFlexParentStyle = () => theme.getUserWidgetFlexParentStyle(theme);
    const [ userWidgetFlexParentStyle, setUserWidgetFlexParentStyle ] = useState(getUserWidgetFlexParentStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setUserWidgetFlexParentStyle(getUserWidgetFlexParentStyle());
    });
    useEffect(resizeEffect);
    return (
        <section style={userWidgetFlexParentStyle}>
            {
                list.map((exchange, index) => <Exchange key={index} exchange={exchange} />)
            }
        </section>
    );
};

const EmptyView = ({ userWidgetHeaderTextStyle }) => 
    <section>
        <p style={userWidgetHeaderTextStyle}>
            You have no archived exchanges.
        </p>
        
    </section>


const WidgetMyArchivedExchangesViewPanel = ({ data }) => {
    const getUserWidgetHeaderTextStyle = () => theme.getUserWidgetHeaderTextStyle(theme);
    const [ userWidgetHeaderTextStyle, setUserWidgetHeaderTextStyle ] = useState(getUserWidgetHeaderTextStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setUserWidgetHeaderTextStyle( getUserWidgetHeaderTextStyle());
    });
    useEffect(resizeEffect);
    return (
        <section>
            <div style={userWidgetHeaderTextStyle}>
                <div>
                    My Past Exchanges
                </div>
            </div>
            {
                data.exchangeList.list.length < 1 ? 
                    <EmptyView userWidgetHeaderTextStyle={userWidgetHeaderTextStyle} /> : 
                        <PopulatedView list={data.exchangeList.list} />
            }
        </section>
    );
};

export default WidgetMyArchivedExchangesViewPanel;
